// Keeps a list page's filters, search text and table page when the user
// opens a detail/edit/add page and then comes back (browser back or a
// "Kembali" button). Opening the list fresh, e.g. from the menu after
// visiting another list, starts clean.
//
// Usage in a list page:
//   mixins: [rememberListState],
//   rememberState: ['searchForm', 'search', 'options'],
//   onListStateRestored () { ... }   // optional, runs right after restoring
//   restoreAfterLoad: ['tableOptions'] // optional, re-applied after isLoading ends
import { previousRoute } from '@/utils/navHistory'

// Route names of pages opened from a list (see router/paths.js)
const RETURN_FROM = /^(Detail|Ubah|Tambah)\b/

function storageKey (vm) {
  // Per role and per list path, so switching roles never mixes filters
  return 'esign:list-state:' + (localStorage.getItem('currentPeran') || '') + ':' + vm.$route.path
}

function read (key) {
  try {
    return JSON.parse(sessionStorage.getItem(key) || 'null')
  } catch (e) {
    return null
  }
}

export default {
  created () {
    const keys = this.$options.rememberState || []
    if (!keys.length) return

    const key = storageKey(this)
    const saved = read(key)
    const prev = previousRoute()

    this.listStateRestored = false
    if (saved && saved.state && prev && RETURN_FROM.test(prev.name || '')) {
      this.listStateRestored = true
      keys.forEach(k => {
        if (Object.prototype.hasOwnProperty.call(saved.state, k)) this[k] = saved.state[k]
      })
      if (typeof this.$options.onListStateRestored === 'function') {
        this.$options.onListStateRestored.call(this)
      }
      // Client-side tables jump back to page 1 when their data (re)loads and
      // the search is applied; re-apply these keys once loading has finished.
      const late = (this.$options.restoreAfterLoad || []).filter(k => Object.prototype.hasOwnProperty.call(saved.state, k))
      if (late.length && 'isLoading' in this) {
        const unwatch = this.$watch('isLoading', loading => {
          if (loading) return
          unwatch()
          this.$nextTick(() => setTimeout(() => {
            late.forEach(k => { this[k] = saved.state[k] })
          }, 0))
        })
      }
    } else {
      try { sessionStorage.removeItem(key) } catch (e) {}
    }
  },

  beforeRouteLeave (to, from, next) {
    const keys = this.$options.rememberState || []
    // Only remember when leaving into a page that returns here
    if (keys.length && RETURN_FROM.test(to.name || '')) {
      const state = {}
      keys.forEach(k => { state[k] = this[k] })
      try { sessionStorage.setItem(storageKey(this), JSON.stringify({ state })) } catch (e) {}
    }
    next()
  }
}
